export const REFRESH_USER_COUNT = "REFRESH_USER_COUNT";

import { get, put, post, destroy, upload } from "utils/fetchRequest";

export const uploadImage = async (data) => {
  try {
    const result = await upload("files/news", data);

    return result;
  } catch (err) {
    return { error: err };
  }
};

export const getNewsList = async (
  searchText,
  type,
  authorId,
  page,
  pageLimit,
  role,
  userRole,
  branch,
  startDate,
  endDate,
  sort,
  order
) => {
  try {
    const result = await get(
      `news?1=1${searchText ? `&search=${searchText}` : ""}${page ? `&page=${page}` : ""}${pageLimit ? `&limit=${pageLimit}` : ""}${type ? `&type=${type}` : ""}${role ? `&branch=${role}` : ""}${userRole ? `&userRole=${userRole}` : ""}${branch ? `&branchIdUser=${branch}` : ""}${startDate ? `&startDate=${startDate}` : ""}${endDate ? `&endDate=${endDate}` : ""}${sort ? `&sort=${sort}` : ""}${order ? `&order=${order}` : ""}`
    );

    return result;
  } catch (err) {
    return { error: err };
  }
};

export const getNewsDelivery = async (searchText) => {
  try {
    const result = await get(
      `news/delivery?1=1${searchText ? `&search=${searchText}` : ""}`
    );

    return result;
  } catch (err) {
    return { error: err };
  }
};

export const getNewsListUser = async (searchText) => {
  try {
    const result = await get(
      `news/count?1=1${searchText ? `&search=${searchText}` : ""}`
    );

    return result;
  } catch (err) {
    return { error: err };
  }
};

export const getNewsListNo = async (searchText) => {
  try {
    const result = await get(
      `news/countNo?1=1${searchText ? `&search=${searchText}` : ""}`
    );

    return result;
  } catch (err) {
    return { error: err };
  }
};

export const getNewsContent = async (newsId) => {
  try {
    const result = await get(`news/${newsId}`);
    return result;
  } catch (err) {
    return { error: err };
  }
};

export const setNewsSeen = async (newsId) => {
  try {
    const result = await put(`news/seen/${newsId}`);
    return result;
  } catch (err) {
    return { error: err };
  }
};

export const createNews = async (data) => {
  try {
    const result = await post("news", data);

    return result;
  } catch (err) {
    return { error: err };
  }
};

export const updateNews = async (id, data) => {
  try {
    const result = await put(`news/${id}`, data);

    return result;
  } catch (err) {
    return { error: err };
  }
};

export const updateNewsDelivery = async (data) => {
  try {
    const result = await put(`news/deliveryupdate/${data.datas}`, {
      data: data,
    });
    return result;
  } catch (err) {
    return { error: err };
  }
};

export const deleteNews = async (id) => {
  try {
    const result = await destroy(`news/${id}`);

    return result;
  } catch (err) {
    return { error: err };
  }
};

export const setSpecial = async (id, data) => {
  try {
    const result = await put(`news/special/${id}`, data);

    return result;
  } catch (err) {
    return { error: err };
  }
};

export const status = async (id, data) => {
  try {
    const result = await put(`news/status/${id}`, data);

    return result;
  } catch (err) {
    return { error: err };
  }
};
